<template>
<div>
    <div class="panel-div">
        <!-- <div class="panel-div2">
            <div>9月15日 12:40</div>
            <div style="position:relative;z-index:-1;">
                <el-image style="width:900px;height:100px;z-index:-1;"></el-image>
                <div style="position:absolute;z-index: 9999;top:70px;left:18px;">2024年招生政策</div>
            </div>
            <div>
                <div style="display:flex;justify-content:space-between;align-items:center;">
                    <div>
                        2023年招生政策
                    </div>
                    <div>
                        <el-image style="width:300px;height:100px;"></el-image>
                    </div>
                </div>
                <div style="display:flex;justify-content:space-between;align-items:center;">
                    <div>
                        2022年招生政策
                    </div>
                    <div>
                        <el-image style="width:300px;height:100px;"></el-image>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div style="display:flex;justify-content:space-between;width:900px;">
            <div>2024年招生政策</div>
            <div>2024-09-23 15:14:30</div>
        </div> -->
        <div class="article-container">
                <div class="article-title">招生政策</div>
                <!-- <div class="article-condition">
                    <el-form :inline="true">
                        <el-form-item label="标题">
                            <el-input v-model="paramObj.title" style="width:200px;" placeholder="请输入标题"></el-input>
                        </el-form-item>
                        <el-form-item label="发布时间段">
                        <el-date-picker
                        v-model="paramObj.timeValue"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="checkPolicy(1,10)">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div> -->
                <!-- <div id="load-data">
                <el-table :data="articleList" border height="560"
                        :header-cell-style="{'background-color':'#B0E2FF','color': '#3B3B3B','border':'1px solid #0099FF','text-align':'center'}"
                        :cell-style="{'border':'1px solid #0099FF','text-align':'center'}" size="small">
                <el-table-column type="index" :index="indexMethod" align="center" label="序号" width="50"></el-table-column>
                <el-table-column show-overflow-tooltip label="标题" prop="title" :resizable="false"></el-table-column>
                <el-table-column show-overflow-tooltip label="发布时间" prop="createTime" :resizable="false"></el-table-column>
                <el-table-column show-overflow-tooltip label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="toPolicyDetail(scope.row.id)">详情</el-button>
                    </template>
                </el-table-column>
                        </el-table>
                </div> -->
                <div>
                    <div style="display:flex;justify-content:space-between;align-items:center;padding:10px" v-for="(item,index) in articleList"
                    :key="index">
                        <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                        <a href="javascript:void(0)" @click="toPolicyDetail(item.id)"
                        style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.title}}</a></div>
                        <div>【{{item.createTime}}】</div>
                    </div>
                </div>
                <!-- <div>
                    <iframe src="https://kdocs.cn/l/ctHssHGLRt3G" width="100%" height="600px"></iframe>
                </div> -->
                <div v-if="articleFlag&&articleObj.total>10" class="article-page-div">
                    <el-pagination
                        @size-change="handlePlanSizeChange"
                        @current-change="handlePlanCurrentChange"
                        :current-page="articleObj.current"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="articleObj.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="articleObj.total">
                    </el-pagination>
                </div>
        </div>
    </div>
</div>
</template>
<script>
import router from '../../../router';
export default {
data(){
    return{
        articleList:[],
        articleObj:{
            current:1,
            pageSize:10,
            total:0
        },
        paramObj:{
            title:"",
            timeValue:null,
            startTime:null,
            endTime:null
        },
        articleFlag:false
    };
},
methods:{
    async handlePlanSizeChange(pageSize){
        await this.getArticleList(this.articleObj.current,pageSize);
    },
    async handlePlanCurrentChange(pageNum){
        await this.getArticleList(pageNum,this.articleObj.pageSize);
    },
    // 跳转到政策详情页
    toPolicyDetail(id){
        const url=router.resolve({
            path:'/policyDetail',
            query:{
                id
            }
        });
        window.open(url.href,"_blank");
    },
    // 返回左侧索引值
    indexMethod(index) {
      if(this.articleObj.current!==1){
        return (this.articleObj.curren-1)*10*(this.articleObj.pageSize/10)+index+1;
      }
      return index+1;
    },
    async checkPolicy(pageNum,pageSize){
        console.log(this.paramObj);
        await this.getArticleList(pageNum,pageSize);
    },
    async getArticleList(pageNum=1,pageSize=10){
        this.articleFlag=false;
        const loading=this.$loading({fullscreen:true,target:document.getElementById("load-data"),text:"正在加载中"});
        const res=await this.$http.getHttp("/policy/getPolicyList?pageNum="+pageNum+"&&pageSize="+pageSize);
        console.log(res);
        if(res.data.data.records.length>0){
            this.articleList=[...res.data.data.records];
            this.articleObj.total=res.data.data.total;
            this.articleObj.current=res.data.data.current;
            this.articleObj.pageSize=res.data.data.size;
        }
        loading.close();
        this.articleFlag=true;
    }
},
async mounted(){
    await this.getArticleList();
}
};
</script>
<style lang="less" scoped>
.panel-div{
    width: 1100px;
    margin: 0 auto;
    a{
        // display: inline-block;
        // padding: 0 16px;
        // font: 16px / 18px Arial, sans-serif;
        // // border-right: 1px solid #666;
        // transition: all 0.3s;
        // color: #666;
    }
}
.panel-div2{
        width: 900px;
        margin: 0 auto;
        text-align: center;
}
.article-container{
    width:1100px;
    margin:0 auto;
    .article-title{
        width:1100px;
        display: flex;
        justify-content: center;
        align-content: center;
        margin:10px 0;
        font-size: 18px;
        font-weight: bold;
    }
    .article-page-div{
        // width:800px;
        display: flex;
        justify-content: center;
        // margin:20px auto;
    }
}
</style>
